import { useCallback } from 'react';
export const useSelection = ({
  state,
  nullable,
  sortedElements,
  favoriteElements,
  elements,
  onSelection,
  handleFilterStringChange,
  handleOpenChange
}) => {
  const handleSelection = useCallback(index => {
    const indexToSelect = index === undefined ? state.activeIndex : index;
    const noValidSelectionIndex = indexToSelect === undefined || indexToSelect === null;
    if (noValidSelectionIndex) {
      handleOpenChange(false);
      return;
    }
    const selectedFavorite = indexToSelect < favoriteElements.length;
    const selectionCandidate = selectedFavorite ? favoriteElements[indexToSelect] : sortedElements?.[indexToSelect - favoriteElements.length];
    const originalIndex = elements.findIndex(elm => elm.id === selectionCandidate.id);
    const hasUndefinedId = selectionCandidate.id === 'UNDEFINED';
    const isNullableOption = !!nullable && hasUndefinedId;
    if (isNullableOption) {
      onSelection?.(undefined, -1);
      handleFilterStringChange(undefined);
    } else {
      // -1 is needed because the first option (index 0) is always the nullable option
      onSelection?.(selectionCandidate.id?.toString(), originalIndex - 1);
      handleFilterStringChange(undefined);
    }
    handleOpenChange(false);
  }, [state.activeIndex, favoriteElements, sortedElements, elements, nullable, handleOpenChange, onSelection, handleFilterStringChange]);
  const handleKeyDown = useCallback(e => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
    if (state.isOpen) {
      switch (e.key) {
        case 'Enter':
        case 'Tab':
          handleSelection();
      }
    } else {
      switch (e.key) {
        case ' ':
        case 'Enter':
          handleOpenChange(true);
      }
    }
  }, [handleOpenChange, handleSelection, state.isOpen]);
  return {
    handleSelection,
    handleKeyDown
  };
};